import { render, staticRenderFns } from "./gangAnxiangqin.vue?vue&type=template&id=061231c0&scoped=true&"
import script from "./gangAnxiangqin.vue?vue&type=script&lang=js&"
export * from "./gangAnxiangqin.vue?vue&type=script&lang=js&"
import style0 from "./gangAnxiangqin.vue?vue&type=style&index=0&id=061231c0&prod&lang=less&"
import style1 from "./gangAnxiangqin.vue?vue&type=style&index=1&id=061231c0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061231c0",
  null
  
)

export default component.exports